import { Link, useLocation } from "react-router-dom";
import { Home, TrendingUp, TrendingDown, PiggyBank, Settings } from "lucide-react";
import { cn } from "@/lib/utils";

export default function BottomNav() {
  const location = useLocation();

  const navItems = [
    { path: "/dashboard", icon: Home, label: "Dashboard" },
    { path: "/income", icon: TrendingUp, label: "Income" },
    { path: "/expenses", icon: TrendingDown, label: "Expenses" },
    { path: "/savings", icon: PiggyBank, label: "Savings" },
    { path: "/settings", icon: Settings, label: "Settings" },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden">
      <div className="flex items-center justify-around h-16 px-2 gap-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                "flex flex-col items-center justify-center gap-1 flex-1 h-[calc(100%-8px)] my-1 transition-all duration-200 rounded-t-2xl",
                "hover:bg-[var(--surface-variant)] active:scale-95",
                "border-2",
                active
                  ? "text-primary-foreground bg-primary border-primary"
                  : "text-muted-foreground bg-[var(--surface-container-high)] border-foreground/20"
              )}
            >
              <Icon className={cn("w-5 h-5 transition-transform", active && "scale-110")} />
              <span className={cn("text-xs font-medium", active && "font-semibold")}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

